import * as React from "react";

function SvgStarIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" {...props}><path d="M95.4 6.3l29.2 58 64.2 9.9-46.2 45.7 10.5 64.1-57.7-29.8L37.6 184l10.5-64.1L2 74.2l64.2-9.9z" /></svg>;
}

export default SvgStarIcon;